module.exports = __webpack_public_path__ + "img/food2.3fe8f4b5.png";